import { render, staticRenderFns } from "./PlayerWinloseLists.vue?vue&type=template&id=76741048&"
import script from "./PlayerWinloseLists.vue?vue&type=script&lang=js&"
export * from "./PlayerWinloseLists.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports